<div
  [innerHTML]="svgContent"
  class="viz-type"
  [class.selected]="selected"
  draggable="true"
  (dragstart)="onDragStart($event)"
></div>
